import { SvgAttribute } from "@/shared/constants/constants";

export const COMPONENT_NAME = "admin-kyc-back";

export const SVG: SvgAttribute = {
  chevron: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.962" fill-rule="evenodd" clip-rule="evenodd" d="M16.5236 19.8043C16.5513 19.5416 16.5123 19.2916 16.4064 19.0543C14.062 16.7177 11.7261 14.374 9.39858 12.0231C11.7261 9.67214 14.062 7.32839 16.4064 4.99182C16.5626 4.6793 16.5626 4.36683 16.4064 4.05432C16.0808 3.74639 15.7137 3.69169 15.3048 3.89025C12.7501 6.44494 10.1955 8.99963 7.64077 11.5543C7.48453 11.8668 7.48453 12.1793 7.64077 12.4918C10.1955 15.0465 12.7501 17.6012 15.3048 20.1559C15.8264 20.4054 16.2326 20.2882 16.5236 19.8043Z" fill="#9E9FA8"/>
  </svg>`,
};
